import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { RPS_FORMULA, rpsProportion } from "../rps";
import { getColor } from "../ScoreChart";

export default function RelativePerformanceScore({ rps }: { rps?: number }) {
  const hasValue = rps !== undefined && rps !== null && Number.isFinite(rps);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
      }}
    >
      <Tooltip title={RPS_FORMULA} placement="top">
        <Typography
          variant="h2"
          component="div"
          sx={{
            fontWeight: 700,
            lineHeight: "100px",
            color: hasValue
              ? getColor(rpsProportion(rps as number))
              : "text.secondary",
          }}
        >
          {hasValue ? (rps as number).toFixed(2) : "--"}
        </Typography>
      </Tooltip>
      <Typography sx={{ lineHeight: "40px" }} color="text.secondary">
        Relative Performance Score
      </Typography>
    </Box>
  );
}
